import { ProductPriceSchedule } from './product-price-schedule';
import { QuantityInLocations } from './quantity-in-location';

export class AreaItem {
  private _id: number;
  private _areaItemPackId: number;
  private _name: string;
  private _group: string;
  private _description: string;
  private _priceDescription: string;
  private _itemQuantity: number;
  private _minutes: number;
  private _price: number;
  private _taxRate: number;
  private _productId: number;
  private _productName: string;
  private _isBirthday: boolean;
  private _isGroup: boolean;
  private _isCashPayment: boolean;
  private _areaIds: number[];
  private _additionalProductIds: number[];
  private _automaticAdditionalProductsIds: number[];
  private _sequence: number;
  private _productPriceSchedules: ProductPriceSchedule[];
  private _productDescription: string;
  private _ticketCountMin: number;
  private _ticketCountMax: number;
  private _openedBooking: boolean;
  private _isPartnerRequired: boolean;
  private _isBirthdayRequired: boolean;
  private _groupSizeMin: number;
  private _groupSizeMax: number;
  private _isStockProduct: boolean;
  private _availableQuantity: number;
  private _quantityInLocations: QuantityInLocations[];
  private _isPhoneRequired: boolean;
  private _isAddressRequired: boolean;
  private _isEmailRequired: boolean;
  private _productSaleDescription: string;

  constructor(
    id: number,
    areaItemPackId: number,
    name: string,
    group: string,
    description: string,
    priceDescription: string,
    itemQuantity: number,
    minutes: number,
    price: number,
    taxRate: number,
    productId: number,
    productName: string,
    isBirthday: boolean,
    isGroup: boolean,
    isCashPayment: boolean,
    areaIds: number[] = null,
    additionalProductsIds: number[] = null,
    automaticAdditionalProductsIds: number[] = null,
    sequence: number,
    productPriceSchedules: ProductPriceSchedule[] = null,
    productDescription: string = null,
    ticketCountMin: number,
    ticketCountMax: number,
    openedBooking: boolean = false,
    isPartnerRequired: boolean = false,
    isBirthdayRequired: boolean = false,
    groupSizeMin = 0,
    groupSizeMax = 0,
    isStockProduct = false,
    availableQuantity = 0,
    quantityInLocations: QuantityInLocations[] = null,
    isPhoneRequired = false,
    isAddressRequired = false,
    isEmailRequired = false,
    productSaleDescription: string = null,
  ) {
    this._id = id;
    this._areaItemPackId = areaItemPackId;
    this._name = name;
    this._group = group;
    this._description = description;
    this._priceDescription = priceDescription;
    this._itemQuantity = itemQuantity;
    this._minutes = minutes;
    this._price = price;
    this._taxRate = taxRate;
    this._productId = productId;
    this._productName = productName;
    this._isBirthday = isBirthday;
    this._isGroup = isGroup;
    this._isCashPayment = isCashPayment;
    this._areaIds = areaIds;
    this._additionalProductIds = additionalProductsIds;
    this._automaticAdditionalProductsIds = automaticAdditionalProductsIds;
    this._sequence = sequence;
    this._productPriceSchedules = productPriceSchedules;
    this._productDescription = productDescription;
    this._productSaleDescription = productSaleDescription;
    this._ticketCountMin = ticketCountMin;
    this._ticketCountMax = ticketCountMax;
    this._openedBooking = openedBooking;
    this._isBirthdayRequired = isBirthdayRequired;
    this._isPartnerRequired = isPartnerRequired;
    this._groupSizeMin = groupSizeMin;
    this._groupSizeMax = groupSizeMax;
    this._isStockProduct = isStockProduct;
    this._availableQuantity = availableQuantity;
    this._quantityInLocations = quantityInLocations;
    this._isPhoneRequired = isPhoneRequired;
    this._isAddressRequired = isAddressRequired;
    this._isEmailRequired = isEmailRequired;
  }

  static createFromAny(object: any): AreaItem {
    if (object === null || object === undefined) {
      return null;
    }

    return new AreaItem(
      object.id,
      object.areaItemPackId,
      object.name ? object.name : '',
      object.group,
      object.description,
      object.priceDescription,
      object.itemQuantity,
      object.minutes,
      object.price,
      object.taxRate,
      object.productId,
      object.productName,
      object.isBirthday,
      object.isGroup,
      object.isCashPayment,
      object.areaIds,
      object.additionalProductsIds,
      object.automaticAdditionalProductsIds,
      object.sequence,
      object.productPriceSchedules ? object.productPriceSchedules.map(x => ProductPriceSchedule.createFromAny(x)) : [],
      object.productDescription,
      object.ticketCountMin ? object.ticketCountMin : 0,
      object.ticketCountMax ? object.ticketCountMax : 0,
      object.openedBooking,
      object.isPartnerRequired,
      object.isBirthdayRequired,
      object.groupSizeMin ? object.groupSizeMin : 0,
      object.groupSizeMax ? object.groupSizeMax : 0,
      object.isStockProduct,
      object.availableQuantity ? object.availableQuantity : 0,
      object.quantityInLocations ? object.quantityInLocations.map(item => QuantityInLocations.createFromAny(item)) : null,
      object.isPhoneRequired,
      object.isAddressRequired,
      object.isEmailRequired,
      object.saleDescription,
    );
  }

  get id(): number {
    return this._id;
  }

  get areaItemPackId(): number {
    return this._areaItemPackId;
  }

  get productId(): number {
    return this._productId;
  }

  get productName(): string {
    return this._productName;
  }

  get name(): string {
    return this._name;
  }

  get group(): string {
    return this._group;
  }

  get description(): string {
    return this._description;
  }

  get priceDescription(): string {
    return this._priceDescription;
  }

  get itemQuantity(): number {
    return this._itemQuantity;
  }

  get minutes(): number {
    return this._minutes;
  }

  get price(): number {
    return this._price;
  }

  get taxRate(): number {
    return this._taxRate;
  }

  get isBirthday(): boolean {
    return this._isBirthday;
  }

  get isGroup(): boolean {
    return this._isGroup;
  }

  get isCashPayment(): boolean {
    return this._isCashPayment;
  }

  get areaIds(): number[] {
    return this._areaIds;
  }

  get additionalProductIds(): number[] {
    return this._additionalProductIds;
  }

  get automaticAdditionalProductsIds(): number[] {
    return this._automaticAdditionalProductsIds;
  }

  get sequence(): number {
    return this._sequence;
  }

  get productPriceSchedules(): ProductPriceSchedule[] {
    return this._productPriceSchedules;
  }

  get productDescription(): string {
    return this._productDescription;
  }

  get productSaleDescription(): string {
    return this._productSaleDescription;
  }

  get ticketCountMin(): number {
    return this._ticketCountMin;
  }

  get ticketCountMax(): number {
    return this._ticketCountMax;
  }

  get openedBooking(): boolean {
    return this._openedBooking;
  }

  get isBirthdayRequired(): boolean {
    return this._isBirthdayRequired;
  }

  get isPartnerRequired(): boolean {
    return this._isPartnerRequired;
  }

  get isGroupBooking(): boolean {
    return this._groupSizeMin > 0 || this._groupSizeMax > 0;
  }

  get groupSizeMin(): number {
    return this._groupSizeMin;
  }

  get groupSizeMax(): number {
    return this._groupSizeMax;
  }

  get isStockProduct(): boolean {
    return this._isStockProduct;
  }

  get availableQuantity(): number {
    return this._availableQuantity;
  }

  setAvailableQuantity(quantity: number, locationId: number) {
    if (this._quantityInLocations) {
      const quantityInLocation = this._quantityInLocations.find(item => item.locationId === locationId);
      if (quantityInLocation) {
        quantityInLocation.quantity = quantity;
      }
    }
  }

  availableMaxQuantity(locationId: number): number {
    let availableQuantity = this._availableQuantity;
    if (this._quantityInLocations) {
      const quantityInLocation = this._quantityInLocations.find(item => item.locationId === locationId);
      if (quantityInLocation) {
        availableQuantity = quantityInLocation.quantity;
      } else {
        availableQuantity = 0;
      }
    }

    const countMax = this.isGroupBooking ? this.groupSizeMax : this.ticketCountMax;
    if (!countMax) {
      return availableQuantity;
    }

    if (this.isStockProduct) {
      return Math.min(countMax, availableQuantity);
    }

    return countMax;
  }

  get isPhoneRequired(): boolean {
    return this._isPhoneRequired;
  }

  get isAddressRequired(): boolean {
    return this._isAddressRequired;
  }

  get isEmailRequired(): boolean {
    return this._isEmailRequired;
  }
}
